import React from 'react';
import { Modal, Button } from '@getro/rombo';
import copy from 'copy-to-clipboard';
import { Copy } from 'lucide-react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { Text, Flex } from 'rebass/styled-components';

import { trackEvent } from '../../../../helpers/analytics';

export const ModalApiKeyCreated = ({ apiKey, onClose }) => {
  const onCopy = () => {
    copy(apiKey);
    toast('Copied!', { icon: 'success', id: 'key-copied-success' });
    trackEvent('api_key:copy');
  };

  return (
    <Modal
      title="API key created"
      onCancel={onClose}
      isOpen
      actions={
        <Flex justifyContent="flex-end" sx={{ gap: '16px' }}>
          <Button onClick={onClose}>Close</Button>
        </Flex>
      }
    >
      <Flex flexDirection="column" sx={{ gap: '8px' }}>
        <Text fontSize="14px">Copy this key now and store it securely, you won&apos;t be able to see it again.</Text>
        <Text fontSize="14px" fontWeight="medium" color="text.dark">
          Important: Never share your API key with others or expose it in the browser or other client-side code.
        </Text>
        <Flex
          alignItems="flex-start"
          justifyContent="space-between"
          bg="neutral.20"
          py="16px"
          px="12px"
          sx={{
            borderRadius: 'default',
            gap: '8px',
          }}
        >
          <Text
            fontSize="14px"
            fontWeight="semibold"
            fontFamily="Source Code Pro, monospace"
            color="text.dark"
            sx={{
              flexGrow: 1,
              mr: '8px',
              wordBreak: 'break-all',
            }}
          >
            {apiKey}
          </Text>
          <Button variant="secondary" size="small" icon={Copy} onClick={onCopy} sx={{ flex: '0 0 auto' }}>
            Copy
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

ModalApiKeyCreated.propTypes = {
  apiKey: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
